import { Grid } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { withStyles } from '@material-ui/styles';
import React from 'react';
import styled, { css } from 'styled-components';

type Props = {
  value: number;
  finished: boolean;
};

const Status = styled.div<Props>`
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;

  ${props =>
    props.value > 0 &&
    css`
      background: ${props => props.theme.palette.secondary.main};
      svg {
        transform: rotate(-45deg);
      }
    `}

  ${props =>
    props.value <= 0 &&
    css`
      background: #d62929;
      svg {
        transform: rotate(45deg);
      }
    `}
`;

const Arrow = withStyles(theme => ({
  root: {
    fontSize: '16px',
    color: '#fff',
    border: 'none'
  }
}))(ArrowForward);

const Value = styled.div<Props>`
  font-size: 14px;

  ${props =>
    props.value > 0 &&
    css`
      color: ${props => props.theme.palette.secondary.main};
    `}

  ${props =>
    props.value <= 0 &&
    css`
      color: #d62929;
    `}
`;

export default function OnTarget({ value, finished }: Props) {
  return (
    <Grid container direction="column" alignItems="flex-end">
      <Status value={value} finished={finished}>
        <Arrow />
      </Status>
      <Value value={value} finished={finished}>
        {(value * 100).toFixed(0)}%
      </Value>
    </Grid>
  );
}
